import React, { useContext } from "react";
import { Navigate } from "react-router-dom";

import PATHS from "../paths";
import { AuthContext } from "../../Library/contexts";
import Authenticated from "./Authenticated/Authenticated";

const ProtectedRoute = ({ noLogin, children }) => {
  const { profile } = useContext(AuthContext);
  const authenticated = !!profile;

  if (noLogin) {
    if (authenticated) return <Navigate to={PATHS.ROOT} />;
    else return children;
  }

  if (authenticated) return <Authenticated />;
  else {
    window.localStorage.removeItem("accessCodes");
    window.localStorage.removeItem("des");

    return <Navigate to={PATHS.LOGIN} />;
  };
};

export default ProtectedRoute;
